import {
	StoreAsyncItem,
	ActionResponse,
	createReducer,
	createAsyncInitialState,
	checkAsyncAction,
} from '@flux';
import { mainPlatformActionsPack } from '../actions';


export type MainPlatformState = {
	tenantAccount: StoreAsyncItem<TenantAccount>;
};

const initialState: MainPlatformState = {
	tenantAccount: createAsyncInitialState([]),
};

const mainPlatformReducer = createReducer(initialState, {
	[mainPlatformActionsPack.types.FETCH_TENANT_ACCOUNT]: (action: ActionResponse<TenantAccount>, state) => {
		return {
			tenantAccount: checkAsyncAction(action, state.tenantAccount),
		};
	},
});

export default mainPlatformReducer;
